import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type DateUnitDataFragment = (
  { __typename: 'DateUnit' }
  & Pick<SchemaTypes.DateUnit, 'unit' | 'value'>
);

export const DateUnitDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DateUnitData on DateUnit {
  unit
  value
}
    `;